// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-deposit-accounts-memo' class="box">

  <sub-header header="\$ctrl.isCredit ? 'Credit memo to account' : 'Debit memo to account'"></sub-header>
    <form-section>

      <div class="info info--deposit">
        <div class="info-detail">
          <span class="key">Product name:</span>
          <span class="value">
            {{\$ctrl.depositAccount.productDefinition.productName}}
          </span>
        </div>
        <div class="info-detail">
          <span class="key">Available balance:</span>
          <span class="value" ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
            {{\$ctrl.depositAccount.balance | nxCurrency}}
          </span>
        </div>
        <div class="info-detail">
          <span class="key">Product branch:</span>
          <span class="value">
            {{\$ctrl.depositAccount.branch.name}}
          </span>
        </div>
        <div class="info-detail">
          <span class="key">Product number:</span>
          <span class="value">
            {{\$ctrl.depositAccount.productNumber}}
          </span>
        </div>
      </div>

      <form name="\$ctrl.categoryForm" novalidate>
        <div class="form-column">
          <form-section-field field-title="'Category'">
            <gl-category-select
              required
              action-type="\$ctrl.isCredit ? 'CREDIT_ACCOUNT_BY_MEMO' : 'DEBIT_ACCOUNT_BY_MEMO'"
              ng-model="\$ctrl.category"
              is-selectize="true"
              ng-change="\$ctrl.categoryChanged()"
              single-accounts-only='false'
            >
            </gl-category-select>
          </form-section-field>
          <form-section-field field-title="'Remarks'">
            <input required class="remarks" type="text" ng-model="\$ctrl.remarks">
          </form-section-field>
        </div>
      </form>

      <gl-category-input units="\$ctrl.categoryUnits"></gl-category-input>

      <form name="\$ctrl.accountsForm" novalidate>
        <table class="table">
          <thead>
            <th class="th--index">#</th>
            <th>Account</th>
            <th>Debit amount</th>
            <th>Credit amount</th>
          </thead>
          <tbody class="tbody">
            <tr ng-if="\$ctrl.isDebit">
              <td></td>
              <td>
                <select disabled>
                <option selected>Product GL account</option>
              </select>
              </td>
              <td>
                <cash value="\$ctrl.calculateAmount().toFixed(2)"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash ng-disabled="true" value="0"></cash>
              </td>
            </tr>

            <tr ng-if="\$ctrl.isCredit">
              <td></td>
              <td>
                <select disabled>
                <option selected>Product GL account</option>
              </select>
              </td>
              <td>
                <cash ng-disabled="true" value="0"></cash>
              </td>
              <td>
                <cash value="\$ctrl.calculateAmount().toFixed(2)"
                  ng-disabled="true"></cash>
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-right">
                Total:
              </td>
              <td>
                <cash value="\$ctrl.calculateAmount().toFixed(2)"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash value="\$ctrl.calculateAmount().toFixed(2)"
                  ng-disabled="true"></cash>
              </td>
            </tr>
          </tbody>
        </table>


        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
          <button ng-if="\$ctrl.isCredit" class="btn btn-success" ng-click="\$ctrl.doOperation()" ng-disabled="!\$ctrl.canExecute()">
            Credit
          </button>
          <button ng-if="\$ctrl.isDebit" class="btn btn-danger" ng-click="\$ctrl.doOperation()" ng-disabled="!\$ctrl.canExecute()">
            Debit
          </button>
        </div>

        <div class="clearfix"></div>
	    </form>
    </form-section>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/memo/memo.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;